import { render, staticRenderFns } from "./infoDialog.vue?vue&type=template&id=65d66014&"
import script from "./infoDialog.vue?vue&type=script&lang=js&"
export * from "./infoDialog.vue?vue&type=script&lang=js&"
import style0 from "./infoDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports